import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/header_logo.png'


const _hoisted_1 = { class: "bg-mentalnc text-gray-700" }
const _hoisted_2 = { class: "p-2 h-12 grid grid-cols-12 content-center" }
const _hoisted_3 = { class: "col-span-4 flex items-center justify-start" }
const _hoisted_4 = { class: "col-span-4 flex items-center justify-center" }
const _hoisted_5 = {
  key: 0,
  class: "col-span-4 flex items-center justify-end"
}
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_icon_text = _resolveComponent("base-icon-text")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layouts_auth_width, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (!_ctx.store.state.menu.sidebar.open)
                  ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('menu/switchSidebarOpen'))),
                      class: "w-7 cursor-pointer",
                      path: _ctx.mdiMenu
                    }, null, 8, ["path"]))
                  : (_openBlock(), _createBlock(_component_base_svg_icon, {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.dispatch('menu/switchSidebarOpen'))),
                      class: "w-7 cursor-pointer",
                      path: _ctx.mdiClose
                    }, null, 8, ["path"]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: _ctx.homePath }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  class: "w-11",
                  src: _imports_0,
                  alt: "LOGO"
                }, null, -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ]),
          (_ctx.props.is_well_labo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", { href: _ctx.wellLaboUrl }, [
                  _createVNode(_component_base_icon_text, {
                    path: _ctx.mdiPlayCircle,
                    text: _ctx.t('word.well_labo'),
                    iconClass: "text-wellLabo",
                    open: true
                  }, null, 8, ["path", "text"])
                ], 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}